<template>
  <v-progress-linear
    :indeterminate="true"
    height="5"
    :active="active"
  ></v-progress-linear>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Progress',
  computed: {
    ...mapGetters({
      counter: 'Progress/get',
    }),
    active: function() {
      return this.counter > 0
    },
  },
}
</script>
<style lang="stylus" scoped>
.v-progress-linear {
  position: absolute;
  top: 65px;
  width: 100%;
  margin: 0;
}
</style>
